export default "/_next/static/videos/Financial-Services-Web-1.mp4";